<ox-alert 
    [whiteBackground]="true" 
    [boldMessage]="true" 
    [margin]="'mb-5'"
    [type]="'family'" 
    role="alert">
    <div class="mb-0 gb-body1 heavy" [translate]="'family_share_alert_1'"></div>
    <div class="mb-0" [translateParams]="{user:user}" [translate]="'family_share_alert_2'"></div>
</ox-alert>
